module.exports = __webpack_public_path__ + "img/about/80243-015.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-015.png
// module id = 25
// module chunks = 0